import React from 'react';
import Form from 'react-bootstrap/Form';
import Dropdown from 'react-bootstrap/Dropdown';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import { useForceUpdate } from '../util';
import { FormValidityProvider, FormValidityReporter } from '../FormValidity';
import { setMusicProperty, getTimeSignature, getMusicPropertyIndices, getMusicPropertyValue, setClef, getClef } from './TaskChordBuilder';
import NumericInput from 'react-numeric-input';
import { isValidKeySignature, isValidNotation } from "./TaskChordBuilder";
import { TabContextReporter } from '../TabContext';
export default function TaskMusicViewer(props) {
  const forceUpdate = useForceUpdate();
  const dataProps = props.data.props;
  const [customTime, setCustomTime] = React.useState(false);
  return /*#__PURE__*/React.createElement(TabContextReporter, {
    index: "0",
    title: "1. Initial Information"
  }, /*#__PURE__*/React.createElement(FormValidityProvider, {
    onChange: props.onValidityChange
  }, /*#__PURE__*/React.createElement(Form, null, /*#__PURE__*/React.createElement(Form.Group, null, /*#__PURE__*/React.createElement(Form.Label, null, /*#__PURE__*/React.createElement("b", null, "Raw ABC String: "), /*#__PURE__*/React.createElement("i", null, "This will override all other options")), /*#__PURE__*/React.createElement(Form.Control, {
    as: "textarea",
    value: dataProps.rawAbc,
    onChange: e => {
      if (e.target.value === "") {
        dataProps.rawAbc = undefined;
      } else {
        dataProps.rawAbc = e.target.value;
      }
      forceUpdate();
      props.onChanged();
    }
  })), /*#__PURE__*/React.createElement(Form.Group, null, /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(Col, null, /*#__PURE__*/React.createElement(Form.Label, null, /*#__PURE__*/React.createElement("b", null, "Clef:")), /*#__PURE__*/React.createElement(Dropdown, {
    className: "mx-2"
  }, /*#__PURE__*/React.createElement(Dropdown.Toggle, {
    id: "dropdown-basic"
  }, getClef(dataProps.musicConfiguration)), /*#__PURE__*/React.createElement(Dropdown.Menu, null, /*#__PURE__*/React.createElement(Dropdown.Item, {
    onClick: e => {
      dataProps.musicConfiguration = setClef(dataProps.musicConfiguration, "treble");
      forceUpdate();
      props.onChanged();
      //props.triggerStateUpdate()
    }
  }, "Treble"), /*#__PURE__*/React.createElement(Dropdown.Item, {
    onClick: e => {
      dataProps.musicConfiguration = setClef(dataProps.musicConfiguration, "bass");
      forceUpdate();
      props.onChanged();
      //props.triggerStateUpdate()
    }
  }, "Bass"), /*#__PURE__*/React.createElement(Dropdown.Item, {
    onClick: e => {
      dataProps.musicConfiguration = setClef(dataProps.musicConfiguration, "alto");
      forceUpdate();
      props.onChanged();
      //props.triggerStateUpdate()
    }
  }, "Alto")))), /*#__PURE__*/React.createElement(Col, null, /*#__PURE__*/React.createElement(Form.Label, null, /*#__PURE__*/React.createElement("b", null, "Time Signature:")), /*#__PURE__*/React.createElement(Dropdown, {
    className: "mx-2"
  }, /*#__PURE__*/React.createElement(Dropdown.Toggle, {
    id: "dropdown-basic"
  }, getTimeSignature(dataProps.musicConfiguration)), /*#__PURE__*/React.createElement(Dropdown.Menu, null, /*#__PURE__*/React.createElement(Dropdown.Item, {
    onClick: e => {
      setCustomTime(false);
      dataProps.musicConfiguration = setMusicProperty(dataProps.musicConfiguration, 'M:', "C");
      forceUpdate();
      props.onChanged();
      //props.triggerStateUpdate()
    }
  }, "Common Time"), /*#__PURE__*/React.createElement(Dropdown.Item, {
    onClick: e => {
      setCustomTime(false);
      dataProps.musicConfiguration = setMusicProperty(dataProps.musicConfiguration, 'M:', "C|");
      forceUpdate();
      props.onChanged();
      //props.triggerStateUpdate()
    }
  }, "Cut Time"), /*#__PURE__*/React.createElement(Dropdown.Item, {
    onClick: e => {
      setCustomTime(false);
      dataProps.musicConfiguration = setMusicProperty(dataProps.musicConfiguration, 'M:', "3/4");
      forceUpdate();
      props.onChanged();
      //props.triggerStateUpdate()
    }
  }, "3/4"), /*#__PURE__*/React.createElement(Dropdown.Item, {
    onClick: e => {
      setCustomTime(false);
      dataProps.musicConfiguration = setMusicProperty(dataProps.musicConfiguration, 'M:', "4/4");
      forceUpdate();
      props.onChanged();
      //props.triggerStateUpdate()
    }
  }, "4/4"), /*#__PURE__*/React.createElement(Dropdown.Item, {
    onClick: e => {
      setCustomTime(false);
      let {
        start,
        end
      } = getMusicPropertyIndices(dataProps.musicConfiguration, 'M:');
      if (end - start < 0) {
        // property doesn't exist
        return '';
      }
      console.log("Clear: ", dataProps.musicConfiguration.slice(start, end), "start: ", start, "end: ", end + 1);
      let mOffset = 2;
      dataProps.musicConfiguration = dataProps.musicConfiguration.replace(dataProps.musicConfiguration.slice(start + mOffset, end + 1), ';');
      forceUpdate();
      props.onChanged();
      //props.triggerStateUpdate()
    }
  }, "Clear"), /*#__PURE__*/React.createElement(Dropdown.Item, {
    onClick: e => {
      setCustomTime(true);
      forceUpdate();
      props.onChanged();
      //props.triggerStateUpdate()
    }
  }, "Custom"))), customTime && /*#__PURE__*/React.createElement(Col, {
    style: {
      margin: "1rem 0rem"
    }
  }, /*#__PURE__*/React.createElement(Form.Control, {
    as: "textarea",
    value: getTimeSignature(dataProps.musicConfiguration),
    onChange: e => {
      dataProps.musicConfiguration = setMusicProperty(dataProps.musicConfiguration, 'M:', e.target.value);
      forceUpdate();
      props.onChanged();
      //props.triggerStateUpdate()
    }
  }))))), /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(Col, {
    xs: 6
  }, /*#__PURE__*/React.createElement(Form.Group, null, /*#__PURE__*/React.createElement(Form.Label, null, /*#__PURE__*/React.createElement("b", null, "Base Note Length:"), " ", /*#__PURE__*/React.createElement("i", null, "The base note value for abc.")), /*#__PURE__*/React.createElement(Dropdown, {
    className: "mx-2"
  }, /*#__PURE__*/React.createElement(Dropdown.Toggle, {
    id: "dropdown-basic"
  }, getMusicPropertyValue(dataProps.musicConfiguration, 'L:')), /*#__PURE__*/React.createElement(Dropdown.Menu, null, /*#__PURE__*/React.createElement(Dropdown.Item, {
    onClick: e => {
      dataProps.musicConfiguration = setMusicProperty(dataProps.musicConfiguration, 'L:', "1/1");
      forceUpdate();
      props.onChanged();
      //props.triggerStateUpdate()
    }
  }, "1/1"), /*#__PURE__*/React.createElement(Dropdown.Item, {
    onClick: e => {
      dataProps.musicConfiguration = setMusicProperty(dataProps.musicConfiguration, 'L:', "1/2");
      forceUpdate();
      props.onChanged();
      //props.triggerStateUpdate()
    }
  }, "1/2"), /*#__PURE__*/React.createElement(Dropdown.Item, {
    onClick: e => {
      dataProps.musicConfiguration = setMusicProperty(dataProps.musicConfiguration, 'L:', "1/4");
      forceUpdate();
      props.onChanged();
      //props.triggerStateUpdate()
    }
  }, "1/4"), /*#__PURE__*/React.createElement(Dropdown.Item, {
    onClick: e => {
      dataProps.musicConfiguration = setMusicProperty(dataProps.musicConfiguration, 'L:', "1/8");
      forceUpdate();
      props.onChanged();
      //props.triggerStateUpdate()
    }
  }, "1/8"), /*#__PURE__*/React.createElement(Dropdown.Item, {
    onClick: e => {
      dataProps.musicConfiguration = setMusicProperty(dataProps.musicConfiguration, 'L:', "1/16");
      forceUpdate();
      props.onChanged();
      //props.triggerStateUpdate()
    }
  }, "1/16"), /*#__PURE__*/React.createElement(Dropdown.Item, {
    onClick: e => {
      dataProps.musicConfiguration = setMusicProperty(dataProps.musicConfiguration, 'L:', "1/32");
      forceUpdate();
      props.onChanged();
      //props.triggerStateUpdate()
    }
  }, "1/32"), /*#__PURE__*/React.createElement(Dropdown.Item, {
    onClick: e => {
      dataProps.musicConfiguration = setMusicProperty(dataProps.musicConfiguration, 'L:', "1/64");
      forceUpdate();
      props.onChanged();
      //props.triggerStateUpdate()
    }
  }, "1/64"))))), /*#__PURE__*/React.createElement(Col, {
    xs: 3
  }, /*#__PURE__*/React.createElement(Form.Group, null, /*#__PURE__*/React.createElement(Form.Label, null, /*#__PURE__*/React.createElement("b", null, "Key:")), /*#__PURE__*/React.createElement(Form.Control, {
    as: "textarea",
    value: getMusicPropertyValue(dataProps.musicConfiguration, 'K:'),
    onChange: e => {
      dataProps.musicConfiguration = setMusicProperty(dataProps.musicConfiguration, 'K:', e.target.value);
      //props.triggerStateUpdate()
      forceUpdate();
    }
  }), /*#__PURE__*/React.createElement(FormValidityReporter, {
    valid: isValidKeySignature(getMusicPropertyValue(dataProps.musicConfiguration, 'K:'))
  }, "Please type in a valid key signature.")))), /*#__PURE__*/React.createElement(Form.Group, null, /*#__PURE__*/React.createElement(Form.Label, null, /*#__PURE__*/React.createElement("b", null, "Measure Time:"), " ", /*#__PURE__*/React.createElement("i", null, "The time it takes to play a measure in miliseconds.")), /*#__PURE__*/React.createElement(NumericInput, {
    min: 0,
    value: parseInt(dataProps.musicDuration),
    onChange: e => {
      if (e) {
        dataProps.musicDuration = e.toString();
        forceUpdate();
        //props.triggerStateUpdate()
      } else {
        dataProps.musicDuration = "0";
        forceUpdate();
        props.onChanged();
      }
    }
  }), /*#__PURE__*/React.createElement(FormValidityReporter, {
    valid: isValidKeySignature(getMusicPropertyValue(dataProps.musicConfiguration, 'K:'))
  }, "Please type in a valid key signature.")), /*#__PURE__*/React.createElement(Form.Group, null, /*#__PURE__*/React.createElement(Form.Label, null, /*#__PURE__*/React.createElement("b", null, "Minimum Height:"), " ", /*#__PURE__*/React.createElement("i", null, "The minimum height of the sheet. Adjust to fit.")), /*#__PURE__*/React.createElement(NumericInput, {
    min: 0,
    value: parseInt(dataProps.minHeight) || 180,
    onChange: e => {
      if (e) {
        dataProps.minHeight = e.toString() + "px";
        props.triggerStateUpdate();
      } else {
        dataProps.minHeight = "0";
        props.triggerStateUpdate();
      }
    }
  })), /*#__PURE__*/React.createElement(Form.Group, null, /*#__PURE__*/React.createElement(Form.Label, null, /*#__PURE__*/React.createElement("b", null, "Initial Score:"), " ", /*#__PURE__*/React.createElement("i", null, "The initial notes to be displayed (abc notation)")), /*#__PURE__*/React.createElement(Form.Control, {
    as: "textarea",
    value: dataProps.musicInitial,
    onChange: e => {
      dataProps.musicInitial = e.target.value;
      //props.triggerStateUpdate()
      forceUpdate();
      props.onChanged();
      //props.triggerStateUpdate()
    }
  })), /*#__PURE__*/React.createElement(Form.Group, {
    style: {
      paddingBottom: '1em'
    }
  }, /*#__PURE__*/React.createElement(Form.Label, null, /*#__PURE__*/React.createElement("b", null, "Range:"), " ", /*#__PURE__*/React.createElement("i", null, "The range (?)")), /*#__PURE__*/React.createElement("div", {
    style: {
      paddingBottom: '.5em'
    }
  }, /*#__PURE__*/React.createElement("span", {
    style: {
      float: 'left'
    }
  }, "Lower:"), /*#__PURE__*/React.createElement("span", {
    style: {
      float: 'right'
    }
  }, /*#__PURE__*/React.createElement(NumericInput, {
    max: dataProps.rangeUpper,
    value: dataProps.rangeLower = dataProps.rangeLower ? dataProps.rangeLower : -3,
    onChange: e => {
      if (e > dataProps.rangeUpper) dataProps.rangeLower = dataProps.rangeUpper;else dataProps.rangeLower = e;
      props.triggerStateUpdate();
    }
  }))), /*#__PURE__*/React.createElement("br", null), /*#__PURE__*/React.createElement("div", {
    style: {
      paddingBottom: '.5em'
    }
  }, /*#__PURE__*/React.createElement("span", {
    style: {
      float: 'left'
    }
  }, "Upper:"), /*#__PURE__*/React.createElement("span", {
    style: {
      float: 'right'
    }
  }, /*#__PURE__*/React.createElement(NumericInput, {
    min: dataProps.rangeLower,
    value: dataProps.rangeUpper = dataProps.rangeUpper ? dataProps.rangeUpper : 15,
    onChange: e => {
      if (e < dataProps.rangeLower) dataProps.rangeUpper = dataProps.rangeLower;else dataProps.rangeUpper = e;
      props.triggerStateUpdate();
    }
  }))), /*#__PURE__*/React.createElement(FormValidityReporter, {
    valid: dataProps.rangeLower <= dataProps.rangeUpper
  }, /*#__PURE__*/React.createElement("br", null), "Ensure the Lower bound is less than the Greater bound.")), /*#__PURE__*/React.createElement(Form.Group, null, /*#__PURE__*/React.createElement(Form.Label, null, /*#__PURE__*/React.createElement("b", null, "Initial Score:"), " ", /*#__PURE__*/React.createElement("i", null, "The initial notes to be displayed (abc notation)")), /*#__PURE__*/React.createElement(Form.Control, {
    as: "textarea",
    value: dataProps.musicInitial,
    onChange: e => {
      dataProps.musicInitial = e.target.value;
      //props.triggerStateUpdate()
      forceUpdate();
      props.onChanged();
    }
  })), /*#__PURE__*/React.createElement(FormValidityReporter, {
    valid: isValidNotation(dataProps.musicConfiguration.split(';').join('\n') + '\n' + dataProps.musicInitial)
  }, "Invalid"))));
}